import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "height", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import IconBase from '../IconBase';
import { jsx as _jsx } from "react/jsx-runtime";

var Youtube = function Youtube(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(IconBase, _objectSpread(_objectSpread({
    $styles: {
      width: width,
      height: height
    },
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M22.9991 9.70998C23.0485 8.27864 22.7355 6.858 22.0891 5.57998C21.6505 5.05558 21.0418 4.70169 20.3691 4.57998C17.5866 4.32751 14.7926 4.22403 11.9991 4.26998C9.2157 4.22194 6.43176 4.32208 3.65905 4.56998C3.11087 4.6697 2.60357 4.92683 2.19905 5.30998C1.29905 6.13998 1.19905 7.55998 1.09905 8.75998C0.953962 10.9175 0.953962 13.0824 1.09905 15.24C1.12798 15.9154 1.22854 16.5858 1.39905 17.24C1.51963 17.745 1.76357 18.2123 2.10905 18.6C2.51632 19.0034 3.03543 19.2752 3.59905 19.38C5.75497 19.6461 7.92727 19.7564 10.0991 19.71C13.5991 19.76 16.669 19.71 20.299 19.43C20.8765 19.3316 21.4102 19.0595 21.8291 18.65C22.109 18.3699 22.3181 18.0271 22.4391 17.65C22.7967 16.5526 22.9723 15.4041 22.959 14.25C22.9991 13.69 22.9991 10.31 22.9991 9.70998ZM9.73905 14.85V8.65998L15.659 11.77C13.9991 12.69 11.809 13.73 9.73905 14.85Z",
      fill: color
    })
  }));
};

export default Youtube;